import { Header, SideBar } from 'components';
import { RouterSuspense } from 'components';
import React from 'react';
import { Outlet } from 'react-router-dom';

import AuthWrapper from '../Wrapper';

const MainLayout = () => {
  return (
    <AuthWrapper>
      <main className='d-flex' style={{ height: '100vh', overflow: 'hidden' }}>
        <SideBar />
        <div
          className='main-content flex-grow-1'
          style={{ overflow: 'auto', display: 'flex', flexDirection: 'column' }}
        >
          <Header />
          <div
            className='container-fluid content pdt40 pdb24 pdl24 pdr24'
            style={{ flex: 1 }}
          >
            <RouterSuspense>
              <Outlet />
            </RouterSuspense>
          </div>
        </div>
      </main>
    </AuthWrapper>
  );
};

export default MainLayout;
